import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { TableUtility } from '@utility/dynamic-table';
import './changeRequest.scss';

const applyToolbarButtonClasses = (rootNode) => {
  if (!rootNode) return;
  rootNode.querySelectorAll('.button-group button').forEach((btn) => {
    const isReset = Boolean(btn.querySelector('.pi-refresh'));
    const isFilter = btn.classList.contains('table-utility-filter-btn');
    const isNew = btn.classList.contains('table-utility-add-new-btn');
    const isExport = !isFilter && !isReset && !isNew && Boolean(btn.querySelector('svg'));
    btn.classList.toggle('change-request-reset-btn', isReset);
    btn.classList.toggle('change-request-export-btn', isExport);
    btn.classList.toggle('change-request-add-btn', isNew);
  });
};

const CRApprovalHistory = ({
  configuration,
  externalFilters,
  tableContainerRef,
  infoMessage,
  tableKey,
}) => {
  const isInitialLoad = useRef(true);
  const domEnhancementRafRef = useRef(null);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (!container) return;

    let observer = null;
    const scheduleEnhancements = () => {
      if (domEnhancementRafRef.current) return;
      domEnhancementRafRef.current = window.requestAnimationFrame(() => {
        domEnhancementRafRef.current = null;
        if (observer) observer.disconnect();

        applyToolbarButtonClasses(container);

        if (observer) observer.observe(container, { childList: true, subtree: true });
      });
    };

    scheduleEnhancements();
    observer = new MutationObserver(() => scheduleEnhancements());
    observer.observe(container, { childList: true, subtree: true });

    return () => {
      if (domEnhancementRafRef.current) {
        window.cancelAnimationFrame(domEnhancementRafRef.current);
        domEnhancementRafRef.current = null;
      }
      if (observer) observer.disconnect();
    };
  }, [tableContainerRef]);

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
    }
  }, []);

  return (
    <div className="cr-approval-history-outer">
      {infoMessage && (
        <div className="cr-approval-info-banner">
          <i className="pi pi-info-circle" />
          <span>{infoMessage}</span>
        </div>
      )}
      <div className="cr-approval-history-table">
        <div className="cr-approval-history-table-utility" ref={tableContainerRef}>
          <TableUtility
            key={tableKey}
            configuration={configuration}
            externalFilters={externalFilters}
          />
        </div>
      </div>
    </div>
  );
};

CRApprovalHistory.propTypes = {
  configuration: PropTypes.object.isRequired,
  externalFilters: PropTypes.array,
  tableContainerRef: PropTypes.shape({ current: PropTypes.any }),
  infoMessage: PropTypes.string,
  tableKey: PropTypes.string,
};

CRApprovalHistory.defaultProps = {
  externalFilters: [],
  tableContainerRef: { current: null },
  infoMessage: '',
  tableKey: '',
};

export default CRApprovalHistory;
